import { Grid, Dialog, DialogContent, DialogTitle, Button, Fab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FichajeCard } from './FichajeCard';
import { getFichajesUsuario } from '../../services/apis';
import { mesName } from '../../utils/utils';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';
import useMediaQuery from "@mui/material/useMediaQuery";

import DialogCorregirFichaje from "./DialogCorregirFichaje";

export const DialogFichajesUsuario = ({ open, onClose, usuarioId, esadmin }) => {

    const [fichajes, setFichajes] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const [nombreMes, setNombreMes] = useState('');
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [nombre, setNombre] = useState(" ");
    const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);

    const [openNuevoCorrector, setOpenNuevoCorrector] = useState(false);
    const isMobile = useMediaQuery("(max-width: 600px)");
    const stylesMobileClose = {
        position: "fixed",
        top: 10,
        right: 10,
        zIndex: 2000,
        width: 42,
        height: 42,
        minWidth: 42,
        borderRadius: "50%",
        fontWeight: "bold"
    };
    const fichajesUsuario = async (id) => {
        try {
            const response = await getFichajesUsuario(mes, yearSelected, id);
            setFichajes(response.data.fichajes);
            setNombre(response.data.nombre.nombre);
            setYears(response.data.years);
            setLoaded(true);
        } catch (error) {
            console.error("Error al obtener fichajes:", error);
        }
    };

    useEffect(() => {
        if (open) {
            fichajesUsuario(usuarioId);
            setNombreMes(mesName(mes));
        }
    }, [open]);

    useEffect(() => {
        fichajesUsuario(usuarioId);
        setNombreMes(mesName(mes));
    }, [mes, yearSelected]);

    return (
        <Dialog open={open} onClose={onClose} fullScreen={isMobile} maxWidth="xl" fullWidth>

            {/* BOTÓN CERRAR SOLO EN MÓVIL */}
            {isMobile && (
                <Fab
                    color="primary"
                    onClick={onClose}
                    sx={stylesMobileClose}
                >
                    X
                </Fab>
            )}

            <DialogContent sx={{ paddingTop: isMobile ? "3.5em" : "1em" }}>

                <Grid container direction="row" justifyContent="space-between" padding="1em">

                    {/* === TÍTULO + BOTÓN (solo PC) === */}
                    <Grid
                        container
                        xs={12}
                        sm={6}
                        justifyContent="flex-start"
                        alignItems="center"
                        gap={2}
                        margin={"1em"}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12}
                        >
                            <h3>Fichajes de {nombre ?? ""}</h3>
                        </Grid>

                        {/* BOTÓN CERRAR SOLO EN ESCRITORIO */}
                        {!isMobile && (
                            <Fab
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={onClose}
                            >
                                X
                            </Fab>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenNuevoCorrector(true)}
                        >
                            Añadir fichaje corrector
                        </Button>
                    </Grid>

                    {/* === SELECTOR MES === */}
                    <Grid container xs={6} sm={4} md={3} justifyContent="center" margin={"1em"}>
                        {mes && <SelectorMes mes={mes} setMes={setMes} />}
                    </Grid>

                    {/* === SELECTOR AÑO === */}
                    <Grid container xs={5} sm={2} md={2} justifyContent="center" margin={"1em"}>
                        {years.length >= 1 && (
                            <SelectorYear
                                years={years}
                                yearSelected={yearSelected}
                                setYearSelected={setYearSelected}
                            />
                        )}
                    </Grid>

                    {/* === MENSAJE NO HAY FICHAJES === */}
                    {fichajes.length <= 0 && (
                        <Grid container xs={12} justifyContent="center" alignItems="center">
                            <strong>Todavía no hay fichajes</strong>
                        </Grid>
                    )}

                    {/* === LISTA DE FICHAJES === */}
                    {fichajes.map((fichaje, index) => (
                        <FichajeCard
                            key={index}
                            fichaje={fichaje}
                            nombreMes={nombreMes}
                            fichajesUsuario={fichajesUsuario}
                            usuarioId={usuarioId}
                            esadmin={esadmin}
                        />
                    ))}
                </Grid>
            </DialogContent>

            {/* === DIALOG PARA NUEVO FICHAJE CORRECTOR === */}
            <DialogCorregirFichaje
                open={openNuevoCorrector}
                onClose={() => {
                    setOpenNuevoCorrector(false);
                    fichajesUsuario(usuarioId);
                }}
                fichaje={null}
                fichajesUsuario={fichajesUsuario}
                usuarioId={usuarioId}
            />
        </Dialog>

    );
};
